import { Spin, Typography } from "antd";
import { showError } from "common/ToastNotifications";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import LoadingOverlay from "components/atoms/LoadingOverlay";
import AdminConsoleTenantList from "components/molecules/AdminConsoleTenantList";
import AppPaths from "constants/appPaths";
import { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
import actions from "store/actions";

const { Title } = Typography;

class AdminConsoleTenants extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fetchingTenants: false,
            busy: false,
            busyMessage: "Please wait...",
            refresh: false,
        };
    }

    componentDidMount() {
        this.props.getAllTenants();
        if (!this.props.allTenantsResult || !this.props.allTenantsResult.Items || this.props.allTenantsResult.Items.length === 0) {
            this.setState({
                fetchingTenants: true,
            });
        } else {
            this.setState({
                refresh: true,
            });
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        this.getAllTenantsResultChanged(prevProps);
    }

    getAllTenantsResultChanged = (prevProps) => {
        if (this.props.getAllTenantsResult && this.props.getAllTenantsResult !== prevProps.getAllTenantsResult) {
            if (!this.props.getAllTenantsResult.success) {
                showError("Unable to get tenants at this moment.");
            }
            this.setState({
                fetchingTenants: false,
                refresh: false,
            });
        }
    };

    componentWillUnmount() {}

    isBusy = () => {
        return this.state.busy || this.state.fetchingTenants;
    };

    showTenantOverview = (tenantId) => {
        this.props.history.push(AppPaths.TENANT_OVERVIEW.replace(":tenantid", tenantId));
    };

    render() {
        return (
            <FlexContainerLayout
                showHeader={true}
                header={
                    <>
                        <Title level={4} className="!mb-0">
                            Tenants
                        </Title>
                        {this.state.refresh ? <Spin size="small" /> : null}
                    </>
                }
                headerClassName="items-center gap-2"
            >
                <LoadingOverlay busy={this.isBusy()} spinner message={this.state.busyMessage || "Please wait..."}></LoadingOverlay>
                {!this.isBusy() && <AdminConsoleTenantList items={this.props.allTenantsResult.Items} onTenantClick={this.showTenantOverview}></AdminConsoleTenantList>}
            </FlexContainerLayout>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        getAllTenantsResult: state.adminConsole.getAllTenantsResult,
        allTenantsResult: state.adminConsole.allTenantsResult,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getAllTenants: () => dispatch(actions.getAllTenantsRequest()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminConsoleTenants));
